import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetEventMediaQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventMediaQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    media?: Array<
      | {
          __typename?: 'MediaPhoto';
          id: string;
          createdAt: { __typename?: 'Date'; milliseconds: number };
          photo: { __typename?: 'Photo'; id: string; url: string; height: number; width: number; assetId: string; mimeType: string; fileSize?: number | null };
        }
      | { __typename?: 'MediaVideo' }
    > | null;
  } | null;
};

export const GetEventMediaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventMedia' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventMediaQuery__
 *
 * To run a query within a React component, call `useGetEventMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventMediaQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventMediaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventMediaQuery, GetEventMediaQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventMediaQuery, GetEventMediaQueryVariables>(GetEventMediaDocument, baseOptions);
}
export function useGetEventMediaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventMediaQuery, GetEventMediaQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventMediaQuery, GetEventMediaQueryVariables>(GetEventMediaDocument, baseOptions);
}
export type GetEventMediaQueryHookResult = ReturnType<typeof useGetEventMediaQuery>;
export type GetEventMediaLazyQueryHookResult = ReturnType<typeof useGetEventMediaLazyQuery>;
export type GetEventMediaQueryResult = Apollo.QueryResult<GetEventMediaQuery, GetEventMediaQueryVariables>;
